<template>
  <li
    v-show="activo"
    class="m-edition-asset-contents-list-item"
  >
    <div
      :class="isCurrentNode
        ? 'm-edition-asset-contents-list-item-data m-edition-asset-contents-list-item-data-current'
        : 'm-edition-asset-contents-list-item-data'"
    >
      <div class="m-edition-asset-contents-list-item-data-node">
        <a
          class="m-edition-asset-contents-list-item-data-node-info"
          href="#"
          @click.prevent="goToNode"
        >
          <i :class="visto ? 'fas fa-check-circle text-color-billing-primary' : 'far fa-circle'"></i>
          <span>{{ nodo.nombre }}</span>
        </a>
        <a
          v-if="nodo.children.length"
          class="m-edition-asset-contents-list-item-data-node-slide"
          href="#"
          @click.prevent="toggleChildren"
        >
          <i :class="showChildren ? 'far fa-minus' : 'far fa-plus'"></i>
        </a>
      </div>
    </div>
    <transition-group
      class="m-edition-asset-contents-list-child"
      name="a-transtion-slide"
      tag="ul"
    >
      <MoleculeEditionAssetContentsTreeNode
        v-for="child in children"
        :key="child.id"
        :contenido="contenido"
        :element="element"
        :info="info"
        :is-child="true"
        :nodo="child"
        @emitAction="emitAction"
      />
    </transition-group>
  </li>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsTreeNode',

  props: {
    contenido: Object,
    element: Object,

    info: {
      type: Object,
      default: null
    },

    isChild: Boolean,
    nodo: Object,

    nodeActions: {
      type: String,
      default: null
    },

    nodeActionsClass: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      showChildren: false
    }
  },

  computed: {
    activo () {
      return this.info.nodosActivos.find(anodo => anodo.nodo === this.nodo.id) !== undefined
    },

    children () {
      return this.showChildren ? this.nodo.children : []
    },

    isCurrentNode () {
      return this.nodo.id === this.$store.getters.getSelectedNode.id
    },

    visto () {
      let nodoActivo = this.info.nodosActivos.find(anodo => anodo.nodo === this.nodo.id)
      return nodoActivo !== undefined ? nodoActivo.visto : false
    }
  },

  methods: {
    emitAction (params) {
      this.$emit('emitAction', params)
    },

    goToNode () {
      let node = this.nodo.texto.length > 0 ? JSON.parse(this.nodo.texto) : { blocks: [] }
      if (this.activo && node.blocks.length > 0 && this.nodo.id !== this.$route.params.subid) {
        this.$store.commit('setSelectedNode', this.nodo)
        this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.content.subject')}/${this.nodo.id}/${this.$t('mEditionMenu.asset.content.children.node.subedition')}`)
      } else if (this.activo && node.blocks.length === 0) {
        this.toggleChildren()
      }
    },

    toggleChildren () {
      this.showChildren = !this.showChildren
    }
  }
}
</script>
